var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fst-UserGenerateAuthToken"},[_c('el-form',{ref:"form",attrs:{"model":_vm.model,"show-message":false,"label-width":"240px","label-position":"left"}},[_c('el-form-item',{domProps:{"innerHTML":_vm._s(_vm.$t('admin.users.generateAuthToken.msg.generate', {name: _vm.user.fullName}))}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }